var _ellipse, _rect, _rect2, _path, _path2, _path3, _ellipse2, _ellipse3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayUserLevel0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 102,
    viewBox: "0 0 80 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.6948,
    cy: 48.57,
    rx: 33.5686,
    ry: 31.9951,
    fill: "#EBEBEB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.7437,
    y: 16.2725,
    width: 20.3641,
    height: 14.6863,
    rx: 2,
    transform: "rotate(-30.018 36.7437 16.2725)",
    fill: "#EBEBEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.8208,
    y: 0.839844,
    width: 20.3641,
    height: 14.6863,
    rx: 2,
    transform: "rotate(52.5921 35.8208 0.839844)",
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.805 63.2811C20.7884 62.8493 19.6246 63.3279 19.2056 64.3499L12.254 81.3097L10.1804 80.5091C6.65215 79.1468 2.72127 80.9155 1.40053 84.4595L0.126977 87.8769C-0.258748 88.9119 0.263887 90.0735 1.29432 90.4713L8.94526 93.4254C9.06944 93.517 9.20602 93.5955 9.35384 93.6583L22.2521 99.1357C23.2688 99.5674 24.4326 99.0889 24.8515 98.0669L35.7857 71.3908C36.2046 70.3688 35.72 69.1902 34.7033 68.7585L21.805 63.2811Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5628 72.3338C40.9221 73.2335 41.1385 74.4731 42.0462 75.1024L57.1089 85.5461L55.8802 87.3983C53.7894 90.55 54.6692 94.7697 57.8453 96.8233L60.9078 98.8035C61.8354 99.4033 63.0823 99.1433 63.6929 98.2229L68.2263 91.3891C68.3426 91.2874 68.4489 91.1709 68.5422 91.0399L76.671 79.6255C77.3117 78.7257 77.0953 77.4861 76.1876 76.8568L52.4954 60.4298C51.5876 59.8004 50.3323 60.0196 49.6916 60.9193L41.5628 72.3338Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4492 85.286L34.6453 73.2223",
    stroke: "#F5F5F5",
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3365,
    cy: 38.6044,
    rx: 1.57353,
    ry: 2.09804,
    fill: "#9C9C9C"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.7288,
    cy: 39.6533,
    rx: 1.57353,
    ry: 2.09804,
    fill: "#9C9C9C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3368 52.8711C23.2649 53.2082 23.4798 53.5421 23.8211 53.5902C24.9033 53.7429 26.0061 53.6955 27.0744 53.4486C28.3457 53.1548 29.537 52.5855 30.5643 51.7809C31.5916 50.9764 32.4298 49.9562 33.0197 48.7924C33.5154 47.8144 33.8257 46.7551 33.9368 45.6679C33.9719 45.3249 33.6992 45.0363 33.3547 45.0253C33.0102 45.0143 32.7246 45.2853 32.6856 45.6278C32.5827 46.5323 32.3193 47.413 31.9062 48.228C31.3989 49.2289 30.6781 50.1062 29.7946 50.7981C28.9111 51.4901 27.8866 51.9796 26.7933 52.2323C25.9031 52.4381 24.9849 52.4827 24.0821 52.3659C23.7402 52.3216 23.4087 52.5339 23.3368 52.8711Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayUserLevel0);
export default __webpack_public_path__ + "static/media/grayUserLevel0.c1b5661008d3b7f65f08ff90d6c5fddc.svg";
export { ForwardRef as ReactComponent };